module.exports = __webpack_public_path__ + "static/media/44493371_2199958196746026_2230715497106636800_o-thumb.580fd762.jpg";